module.exports = __webpack_public_path__ + "static/media/python.fd698436.png";